/**
 * Helpers for building Microsoft Clarity timeline event names from HTTP
 * requests/responses, per the API Event Logs spec:
 *  - api_success_[METHOD]_[sanitizedPath]
 *  - api_fail_[METHOD]_[sanitizedPath]_code_[statusCode]_msg_[sanitizedErrorMessage]
 *  - api_fail_[METHOD]_[sanitizedPath]_code_0_msg_[sanitizedException]   (network/timeout)
 */

const MONGO_ID = /[0-9a-fA-F]{24}/g;
const UUID = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;
const NUMERIC_SEGMENT = /\/\d+(?=\/|$)/g;
const MAX_LENGTH = 250;

/** Strips dynamic segments (Mongo IDs, UUIDs, numeric IDs) from a path, replacing them with "id". */
export function cleanPath(rawPath: string): string {
  let path = (rawPath || '').split('?')[0];
  path = path.replace(UUID, 'id');
  path = path.replace(MONGO_ID, 'id');
  path = path.replace(NUMERIC_SEGMENT, '/id');
  return path;
}

/** Replaces slashes, question marks, and other special characters with underscores. */
export function normalizeString(input: string): string {
  return (input || '')
    .replace(/[\/\?&=#%]+/g, '_')
    .replace(/[^a-zA-Z0-9_]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
}

function truncate(str: string): string {
  return str.length > MAX_LENGTH ? str.slice(0, MAX_LENGTH) : str;
}

export function buildSuccessEventName(method: string, rawPath: string): string {
  const sanitizedPath = normalizeString(cleanPath(rawPath));
  return truncate(`api_success_${method.toUpperCase()}_${sanitizedPath}`);
}

export function buildFailureEventName(
  method: string,
  rawPath: string,
  statusCode: number,
  errorMessage: string,
): string {
  const sanitizedPath = normalizeString(cleanPath(rawPath));
  const sanitizedMessage = normalizeString(errorMessage || 'unknown_error');
  return truncate(
    `api_fail_${method.toUpperCase()}_${sanitizedPath}_code_${statusCode}_msg_${sanitizedMessage}`,
  );
}
